import UserCardWithInput from './UserCardWithInput';
import { Row, Col, Container } from 'react-bootstrap';
import { useState } from 'react';
import profiles from '../../data/profiles/profiles.json';
import { Profile } from '../../types';

const UserCardWithInputDemo = () => {
  const demoProfiles = profiles.data;
  const [initialValue, setValue] = useState<number | null | undefined>(null);
  const [profs, setProfiles] = useState(demoProfiles);

  const handleRemoveItem = (profile: Profile) => {
    const items = profs.filter((item) => item.id !== profile.id);
    setProfiles(items);
  };

  const handleChange = (value: number | null | undefined) => {
    setValue(value);
  };
  return (
    <Container>
      <Row>
        {profs.map((profile: Profile, idx) => {
          return (
            <Col className="col-12 col-lg-6 mb-7">
              <UserCardWithInput
                numberInputValue={initialValue}
                onChange={handleChange}
                item={profile}
                key={idx}
                onClick={() => handleRemoveItem(profile)}
              />
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default UserCardWithInputDemo;
